import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const toHoursAndMinutes = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60 / 60);
  const minutes = Math.floor(totalMinutes / 60);
  const seconds = totalMinutes % 60;

  return {
    hours,
    minutes,
    seconds,
  };
};

export const getDuration = (start, end) => {
  const diff = dayjs(end).diff(dayjs(start));
  return dayjs(diff).utc().format('HH:mm:ss');
};
